import { render, staticRenderFns } from "./task-badge-state.vue?vue&type=template&id=07799fe9&"
import script from "./task-badge-state.vue?vue&type=script&lang=js&"
export * from "./task-badge-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports